<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="pagetemplates">
					<app-heading :title="`${template.name} Page Templates`" />
					<app-row>
						<app-cell>
							<app-data-table
								:items="pageTemplates"
								:headers="headers"
								:total="count"
								:refresh.sync="refresh"
								:initial-state="tableState"
								@update="fetchPageTemplates"
							>
								<template v-slot:website="{ item }">
									{{ item.website ? item.website.name : '-' }}
								</template>
								<template v-slot:page="{ item }">
									{{ item.page ? item.page.name : '-' }}
								</template>
								<template v-slot:actions="{ item }">
									<app-button-confirm
										v-if="$ravello.can('pagetemplate.delete')"
										color="error"
										icon="fa-trash"
										table
										label-confirm="Remove"
										:description="`Are you sure you want to remove page template <b>${item.name}</b>?`"
										title="Remove Page Template"
										@click="onDelete(item._id)"
									>
										Remove
									</app-button-confirm>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { websiteTemplateContentTabs } from '@/datasources/tabs'
import { filters, tableState } from '@/mixins'

export default {
	mixins: [filters, tableState],
	data() {
		return {
			template: {
				name: '',
				slug: '',
			},
			tabs: [],
			pageTemplates: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Template Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Website',
				value: 'website',
				sortable: false,
			}, {
				text: 'Page',
				value: 'page',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				width: '15%',
				sortable: false,
			}],
		}
	},
	computed: {
		templateId() {
			return this.$route.params.template
		},
	},
	async mounted() {
		this.template = await this.$ravello.graphql('websitetemplate', this.templateId)
			.fields(['name', 'slug'])
			.query()

		this.tabs = websiteTemplateContentTabs(this.templateId)
	},
	methods: {
		async fetchPageTemplates(pagination) {
			this.updateTableState(pagination)

			const request = this.$ravello.graphql('pagetemplates')
				.fields(['_id', 'name'])
				.include(this.$ravello.graphql('website').fields(['_id', 'name']))
				.include(this.$ravello.graphql('page').fields(['_id', 'name']))
				.filter('template', this.templateId)
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}

			try {
				this.pageTemplates = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('pagetemplates')
					.to(id)
					.delete()

				this.refresh = true
				this.$notifications.pushAlert('success', 'Page template deleted successfully')
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
